module.exports = require("react-collapse");


//////////////////
// WEBPACK FOOTER
// external "react-collapse"
// module id = 266
// module chunks = 0